import { DwgFetcher } from './DwgFetcher.js'

export default {
  extensions: ['dwg'],
  async load(url, options={}) {
    const fetcher = new DwgFetcher(url, options)
    return await fetcher.Fetch(options.progressCbk)
  }
}
